import { render, staticRenderFns } from "./TrainingCoursesCrudFiles.vue?vue&type=template&id=390b9ef5&"
import script from "./TrainingCoursesCrudFiles.vue?vue&type=script&lang=js&"
export * from "./TrainingCoursesCrudFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports